import CategoryForm from "../../../../component/CategoryForm/CategoryForm";
import { useEffect, useState} from "react";
import Loading from "../../../../component/Loading/Loading";

const NewsCategoryForm = ({newsCategory, onChange}) => {


    return (
        <CategoryForm category={newsCategory.category} onChange={(value) => {
            const newCategory = {...value};
            onChange({...newsCategory , category : newCategory});
        }} />
    );
}

export default NewsCategoryForm;